const BlogDetailSkeleton = () => (
  <article className="blog-detail-article blog-detail-skeleton" aria-hidden="true">
    <div className="blog-skeleton-line blog-skeleton-title" />
    <div className="blog-skeleton-line blog-skeleton-title-short" />
    <div className="blog-skeleton-meta">
      <div className="blog-skeleton-pill" />
      <div className="blog-skeleton-pill blog-skeleton-pill-sm" />
    </div>
    <div className="blog-skeleton-banner blog-detail-banner" />
    <div className="blog-skeleton-line" />
    <div className="blog-skeleton-line" />
    <div className="blog-skeleton-line blog-skeleton-line-md" />
    <div className="blog-skeleton-line" />
    <div className="blog-skeleton-line blog-skeleton-line-short" />
  </article>
);

export default BlogDetailSkeleton;
